import { render, staticRenderFns } from "./ByVirtualTariffFromDexNetTokenModal.vue?vue&type=template&id=6b1b7db8&scoped=true"
import script from "./ByVirtualTariffFromDexNetTokenModal.vue?vue&type=script&lang=ts"
export * from "./ByVirtualTariffFromDexNetTokenModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1b7db8",
  null
  
)

export default component.exports